import {  useState,useRef,useEffect } from "react"
import { Box, Table, Thead, Tbody, Tr, Th, Td, TableContainer, Icon,  Button,SkeletonCircle,SkeletonText,
    InputGroup, InputLeftElement,Input, Stack,Select, Text } from "@chakra-ui/react"
import { MdCheckBox, MdCheckBoxOutlineBlank,MdSaveAlt,MdCancel } from "react-icons/md"
import { SearchIcon } from "@chakra-ui/icons"
import GruntPager from "../custom/GruntPager"
export const GovedaListForSpecifikacija=({knjige=[] ,goveda=[], preselected=[] ,onSelect ,size = 'xs',onClose,onFinishSelectGoveda,onSelectKnjiga })=>{
    const [data, setData] = useState([])
    const [selectedgovid,setSelectedGovId]=useState(preselected)
    const [filter,setFilter]=useState("");
    const [isloading,setIsLoading]=useState(true)
    const [prikaz, setPrikaz] = useState({orderbycol:"datum",orderby:"desc",rowsperpage:18,currpage:1});
    const [selectedknjigaid,setSelectedKnjigaId]=useState(0)
    const srchGrloRef=useRef(null);

    useEffect(() => {
      const _d=goveda.map((item)=>{return {...item,filtered:true}});
      
      _d.forEach((item)=>{
        if (selectedgovid.findIndex((itm)=>itm===item.govedo_id)!==-1) {
            item.selected=true;
            
        } else {
            item.selected=false;
        }
      })

      _d.sort((a,b)=>{
        let _res=0;
        if (a.selected && !b.selected) {
            _res=-1;
        }
        if (!a.selected && b.selected) {
            _res=1;
        }
        if (a.selected===b.selected) {
            if (a.putnica_oznaka<b.putnica_oznaka) {
                _res=-1;
            } else {
                _res=1;
            }
        }
        return _res;
      })
        //selected:selectedgovedaid.findIndex((item2)=>item2===item.govedo_id)===-1?false:true}})
      setData(_d)
      setIsLoading(false);
    }, [goveda])
    


    const finshSelectGoveda=()=>{
        onFinishSelectGoveda();
    }
    const showSelected=(selected)=>{
        if (selected) {
          return <Icon as={MdCheckBox} boxSize={5}/>
        } else {
          return <Icon as={MdCheckBoxOutlineBlank} boxSize={5}/>
        }
    }
    

    

    const setSelected=(_govid)=>{
        const _s=[...selectedgovid];
        const _i=_s.findIndex((item)=>item===_govid);
        if (_i===-1) {
            _s.push(_govid);
        } else {
            _s.splice(_i,1);
        }
        
        const _newdata=[...data];
        const _idx=_newdata.findIndex((item)=>item.govedo_id===_govid);
        if (_i===-1) {
            _newdata[_idx].selected=true;
        } else {
            _newdata[_idx].selected=false;
        }
        setData(_newdata);
        setSelectedGovId(_s);
        onSelect(_s);
        srchGrloRef.current.focus();
        srchGrloRef.current.select();
    }

    const SetFilter=(e)=>{
        //const _val=e.target.value;
        let _ar=data;
       
        const _val0=e.target.value.toUpperCase();
        const _val=_val0.replaceAll("_",".").replaceAll("*",".*");

        const _rgxstr="^.*" + _val+"$"; 
        const _r=new RegExp(_rgxstr);
        let _test=false;
        let _i=0;
        _ar.forEach((gov)=>{
          _test=_r.test(gov.zivbr) || _val0==="";
          gov.filtered=_test;
          if (_test) {
            _i++;
          }

        })
        
            setPrikaz({...prikaz,currpage:1})
        
        setData(_ar)
        setFilter(_val0);
        /*setState({...state,goveda:_ar,filter:_val0});
        setPrikaz({...prikaz,numOfRowsToShow:_i});*/
        
    }

const handleOnSelectKnjiga=(e)=>{
    if (e.target.value!=="") {
        setIsLoading(true);
        setSelectedKnjigaId(e.target.value);
        onSelectKnjiga(e.target.value);    
    } else {
        setData([])
    }
    

}
    const getSearchBox=()=>{
        return (
            <Box display={'flex'} flexDir={'row'} h={'2rem'} alignItems={'center'} mb={'0.5rem'}>
                <InputGroup size={size} w={'50%'} alignContent={'center'} >
                  <InputLeftElement h={'full'} pointerEvents={'none'} children={<SearchIcon/>}></InputLeftElement>
                  <Input focusBorderColor='grunt2.400' ref={srchGrloRef} value={filter} variant={'outline'} placeholder={'* (više znakova), _ (jedan znak)'} w={'1000%'} onChange={SetFilter}></Input>
                </InputGroup>
                <Select focusBorderColor='grunt2.400' variant={'outline'} placeholder='Knjiga' size={size} w={'50%'} onChange={handleOnSelectKnjiga}>
                    {
                        knjige.map((item,index)=>{
                            return (
                                <option key={`knj${index}`} id={`opt_${item.id}`} value={item.id}>{item.naziv}</option>
                            )
                        })
                    }
                
                </Select>
            </Box>
        )
    }
    const buildScreen = () => {
        if (!isloading) {
            return (
                <Box display={'flex'} flexDir={'column'} flex={1}>
                   
                <TableContainer >
                    <Table variant={'unstyled'} size={size}>
                        <Thead _hover={{ cursor: 'pointer' }} fontSize={size}>
                            <Tr>
                                <Th w={'15%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Životni br.</Th>
                                <Th w={'5%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Spol</Th>
                                <Th w={'45'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Pasmina</Th>
                                <Th w={'20%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Oznaka na putnici</Th>
                                <Th w={'15%'} textAlign={'center'} zIndex='5' color={'grunt2.800'} borderTopWidth={'1px'} borderTopColor={'black'} borderBottomWidth={'1px'} borderBottomColor={'black'}>Odaberi</Th>
                                
                            </Tr>
                        </Thead>
                        <Tbody>
                            {data.filter((item)=>item.filtered===true).slice((prikaz.currpage-1)*prikaz.rowsperpage,prikaz.currpage*prikaz.rowsperpage).map((item, i) => {
                                return (
                                    <Tr color={'grunt2'} key={item.govedo_id} bg={'white'} fontWeight={'normal'}
                                        _hover={{ bg: 'gray.100', cursor: 'pointer' }} h='2rem' onClick={()=>setSelected(item.govedo_id)}>
                                        <Td fontSize={size} textAlign={'center'}>{item.zivbr}</Td>
                                        <Td fontSize={size} textAlign={'center'}>{item.spol.toLowerCase()==="m"?"M":"Ž"}</Td>
                                        <Td fontSize={size} textAlign={'center'}>{item.pasmina}</Td>
                                        <Td fontSize={size} textAlign={'center'}>{item.putnica_oznaka}</Td>
                                        <Td fontSize={size} textAlign={'center'}>{showSelected(item.selected)}</Td>
                                    </Tr>
                                )
                            })}
                        </Tbody>
                    </Table>
                </TableContainer>
                </Box>
            )
        } else {
            
                  return (
                    <Box display={'flex'} flexDir={'column'} flex={1}>
                        <SkeletonCircle size='10' />
                        <SkeletonText mt='4' noOfLines={15} spacing='4' skeletonHeight='4' />
                    </Box>
                  )
                
        }
            
        
    }
    const getControls=()=>{
        return (
            <Box display={'flex'} flexDir={'row'} h={'2rem'} mt={'1.5rem'}>
                <Stack direction={'row'} spacing={'2rem'} flex={1}>
                    <Button rightIcon={<MdSaveAlt/>} size={'xs'} colorScheme={'grunt2'} variant={'outline'} onClick={finshSelectGoveda}>Prihvati</Button>
                    <Button rightIcon={<MdCancel/>} size={size} colorScheme={'grunt2'} variant={'outline'} onClick={onClose}>Odustani</Button>
                </Stack>
            </Box>
        )
    }
    const getPager=()=>{
        return (
            <Box display={'flex'} flexDir={'rov'} alignItems={'center'} justifyContent={'center'}>
                <GruntPager currpage={prikaz.currpage} rowcount={data.filter((item)=>item.filtered===true).length} rowsperpage={prikaz.rowsperpage} onClick={(pagenum)=>setPrikaz({...prikaz,currpage:pagenum})}/>
            </Box>
        )
    }
    return (
        <Box display={'flex'} flexDir={'column'} flex={1}>
            <Box display={'flex'} flexDir={'row'} h={'1.5rem'} bg={'grunt2.700'} justifyContent={'center'} 
            alignItems={'center'} borderTopLeftRadius={3} borderTopRightRadius={3}>
                    <Text color={'white'} fontSize={'sm'} fontWeight={'semibold'}>Goveda</Text>
            </Box>
            {getSearchBox()}
            {buildScreen()}
            {getPager()}
            {getControls()}
        </Box>
    )

}